import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  StyleSheet,
  Text,
  TextInput,
  View,
} from './components/base_components';
import BreadcrumbPath from './components/breadcrumb_path';
import StandardBoxList from './components/standard_box_list';
import TextButton from './components/buttons/text_button';

import DirStore from './stores/dir_store';
import MediaGrantStore from './stores/media_grant_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  createFolderScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  dialog: {
    marginLeft: '2rem',
    marginBottom: '2rem',
    flexDirection: 'column',
  },
  text: {
    marginTop: '1em',
    fontSize: '1.5em',
  },
  input: {
    alignSelf: 'stretch',
    maxWidth: '40rem',
    marginTop: '1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: '4rem',
    color: '#555',
    fontSize: '1.5rem',
    borderRadius: '0.5rem',
    borderWidth: 1,
    borderColor: '#ccc',
    backgroundColor: '#f5f5f5',
  },
  button: {
    marginTop: '1rem',
    alignSelf: 'flex-start',
  },
});

export default function CreateFolderScreen(props) {
  const params = useParams();
  const org = UserStore.useOrg();
  const grant_name = params.grant_name ?? '';
  const path = '/' + (params['*'] ?? '');
  const grant = MediaGrantStore.useMediaGrant(org?.org_id, grant_name);
  const media_grant_id = grant?.media_grant_id;
  const [new_dir, setNewDir] = React.useState('');
  const navigate = useNavigate();

  React.useEffect(() => {
    MediaGrantStore.fetch(org?.org_id);
  }, [org?.org_id]);

  function _onCreatePress() {
    DirStore.createDir({ media_grant_id, path, new_dir });
    navigate(`/home/${grant_name}${path}${new_dir}/`);
  }

  return (
    <View style={styles.createFolderScreen}>
      <BreadcrumbPath
        volumeName={grant?.grant_name}
        prefix={`/home/${grant?.grant_name}/`}
        path={path}
        extra='Create Folder'
      />
      <StandardBoxList title='New Folder'>
        <View style={styles.dialog}>
          <Text style={styles.text}>Create a new folder.</Text>
          <TextInput
            style={styles.input}
            placeholder='New Folder Name'
            value={new_dir}
            onChangeText={setNewDir}
          />
          <TextButton
            style={styles.button}
            text='Create Folder'
            onPress={_onCreatePress}
          />
        </View>
      </StandardBoxList>
    </View>
  );
}
